import './SonarUserTooltip.scss';
import { Tooltip } from 'antd';
import React from 'react';
export const SonarUserTooltip = ({ avatar, children, email, name }) => {
    const tooltipContent = React.createElement("div", { className: 'tooltip-content' },
        avatar,
        React.createElement("div", { className: 'tooltip-details' },
            React.createElement("div", null, name),
            React.createElement("div", null, email)));
    return (React.createElement(Tooltip, { mouseEnterDelay: 0.5, overlayClassName: 'user-tooltip', placement: 'top', title: tooltipContent }, children));
};
